import React from 'react';
import { useParams } from 'react-router-dom';
import FetchData from '@/components/FetchData';
import Loading from '@/components/Loading';
import Error from '@/components/Error';
import Controller from './Controller';


function GameContainer() {
  const params = useParams();
  return (
    <FetchData {...params}>
      {({ loading, error, response, url}) => (
        <Loading loading={loading}>
          <Error error={error}>
            <Controller data={response} output={url} />
          </Error>
        </Loading>
      )}
    </FetchData>
  );
}

export default GameContainer;
